import { GET_MAQUINAS_CENTRO_DESTINO, MOVE_MAQUINA_TO_CENTRO_DESINO } from '../constants/action_types';

const initialState = { maquinas: [], refresh: false, isLoading: false, moveSuccess: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINAS_CENTRO_DESTINO:

            return { maquinas: [], refresh: false, isLoading: true, moveSuccess: false };

        case GET_MAQUINAS_CENTRO_DESTINO + "_SUCCESS":

            return { maquinas: action.payload.data, refresh: false, isLoading: false, smoveSuccess: false };

        case MOVE_MAQUINA_TO_CENTRO_DESINO + "_SUCCESS":

            return { maquinas: action.payload.data, refresh: true, isLoading: false, moveSuccess: true };

        default:

            return state;
    }

}